"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NodeJSUtil = /** @class */ (function () {
    function NodeJSUtil() {
    }
    /**
     * Return true if the code is run in a NodeJS Environment
     */
    NodeJSUtil.isNode = function () {
        return typeof process !== 'undefined';
    };
    NodeJSUtil.getEnvVariable = function (variableName) {
        return NodeJSUtil.isNode() && process.env ? process.env[variableName] : undefined;
    };
    NodeJSUtil.getNodeEnv = function () {
        return NodeJSUtil.getEnvVariable('NODE_ENV');
    };
    return NodeJSUtil;
}());
exports.default = NodeJSUtil;
//# sourceMappingURL=NodeJSUtil.js.map